import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../services/auth';
import { clearStorage } from '../services/storageManager'

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await logoutUser();
            } catch (error) {
                console.error('Erreur lors de la déconnexion:', error);
            }
            navigate('/');
        };

        performLogout();
        clearStorage(); // Clear all storage data
    }, [navigate]);

    return (
        <div>
            <p>Déconnexion en cours...</p>
        </div>
    );
};

export default Logout;